export interface SelectedWidgetData {
  filter: any;
  tableType: TableDataType;
  [key: string]: any; // Allows for other widget-specific properties like index, value, name
}
export enum TableDataType {
  ALERT = 'ALERT',
  INCIDENT = 'INCIDENT',
}

export enum EntityTypes {
  ASSET = 'ASSET',
  USER = 'USER',
}

export interface FilterContext {
  filters: any;
  dateRange: Date[];
  typeMap: any;
  search?: {
    field: string;
    term: string;
  };
}

export enum InteractiveWidgetType {
  MeanTimeToRespond = 'MeanTimeToRespond',
  Top5AttackedEntities = 'Top5AttackedEntities',
  Top5Vendors = 'Top5Vendors',
  AlertsMappedToTactic = 'AlertsMappedToTactic',
  IncidentStatus = 'IncidentStatus',
}
